"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEntityColumnDisplay = void 0;
const lodash_1 = require("lodash");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@dnd-kit/core");
const sortable_1 = require("@dnd-kit/sortable");
const core_2 = require("@material-ui/core");
const entity_ui_1 = require("@sierralabs/entity-ui");
const SortableQueryFieldSelector_1 = require("./SortableQueryFieldSelector");
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const StyledDiv = styled_components_1.default.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  &.vertical {
    flex-direction: column;
    overflow: hidden;
    flex: 1 1 auto;
    .column-selector {
      margin-right: 0;
      max-width: 100%;
      flex: 1 1 auto;
    }
  }
  .column-selector {
    /* margin-right: 6px; */
  }
  .add-button-container {
    padding-top: 4px;
  }
`;
const ColumnsSelector = ({ config: configProp, multiple, freesolo, value, error, helperText, vertical, queryAliasColumnMap: queryAliasColumnMapProp, onChange, onFreeSoloChange, onColumnChange, onMove, onDelete }) => {
    const [shouldAutoFocus, setShouldAutoFocus] = (0, react_1.useState)(false);
    const { queryManager } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const { entities } = (0, entity_ui_1.useEntityContext)();
    const [dragColumnMap, setDragColumnMap] = (0, react_1.useState)();
    const setEmptyValue = () => (multiple ? [] : [undefined]);
    const [selectedColumnMaps, setSelectedColumnMaps] = (0, react_1.useState)(
    // load an empty field if no value provided for single column selection
    setEmptyValue());
    // refresh column map when selected columns change
    (0, react_1.useEffect)(() => {
        if (!entities) {
            return;
        }
        setSelectedColumnMaps(!value
            ? setEmptyValue() // set to empty
            : getQueryAliasColumnMap(multiple ? value : [value], queryManager, configProp));
    }, [configProp, entities, multiple, queryManager, queryManager.query, value]);
    //   const value = valueRef.current;
    //   if (config && entities && value) {
    //     setSelectedColumnMaps(
    //       getQueryAliasColumnMap(
    //         multiple ? (value as string[]) : [value as string],
    //         config,
    //         entities
    //       )
    //     );
    //   }
    // }, [config, entities, multiple]);
    // remove any columns from options that are already selected
    const filteredOptions = (0, react_1.useMemo)(() => {
        const queryAliasColumnMap = queryAliasColumnMapProp || queryManager.queryAliasColumnMap;
        const filtered = queryAliasColumnMap.filter(columMap => {
            return !selectedColumnMaps.some(selected => (selected === null || selected === void 0 ? void 0 : selected.path) === columMap.path);
        });
        const queryExpression = configProp || queryManager.query.config;
        if (!queryExpression) {
            return filtered;
        }
        // transform similar to setSelectedColumnMaps() to have proper alias values
        return getQueryAliasColumnMap(filtered.map(columnMap => columnMap.path || columnMap.value || ''), queryManager, queryExpression);
    }, [configProp, queryAliasColumnMapProp, queryManager, selectedColumnMaps]);
    // persist drag index change
    const dragChangeRef = (0, react_1.useRef)({ sourceIndex: 0, targetIndex: 0 });
    // dnd-kit drag sensors
    const sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor)
    // useSensor(KeyboardSensor, {
    //   coordinateGetter: sortableKeyboardCoordinates
    // })
    );
    const classes = ['column-selector-container'];
    if (vertical)
        classes.push('vertical');
    return (react_1.default.createElement(core_1.DndContext, { sensors: sensors, onDragStart: event => {
            const index = selectedColumnMaps.findIndex(cm => (cm === null || cm === void 0 ? void 0 : cm.path) === event.active.id);
            // store original source index for use when saving to server
            dragChangeRef.current.sourceIndex = index;
            dragChangeRef.current.targetIndex = index;
            const columnMap = selectedColumnMaps[index];
            setDragColumnMap(columnMap);
        }, onDragOver: event => {
            const { active, over } = event;
            if (over && active.id !== over.id) {
                setSelectedColumnMaps(columnMaps => {
                    const sourceIndex = columnMaps.findIndex(cm => (cm === null || cm === void 0 ? void 0 : cm.path) === active.id);
                    const targetIndex = columnMaps.findIndex(cm => (cm === null || cm === void 0 ? void 0 : cm.path) === over.id);
                    // store target index for use when saving
                    dragChangeRef.current.targetIndex = targetIndex;
                    return (0, sortable_1.arrayMove)(columnMaps, sourceIndex, targetIndex);
                });
            }
        }, onDragEnd: () => {
            // check original source and target index
            const { sourceIndex, targetIndex } = dragChangeRef.current;
            if (sourceIndex > -1 &&
                targetIndex > -1 &&
                sourceIndex !== targetIndex) {
                onMove === null || onMove === void 0 ? void 0 : onMove(sourceIndex, targetIndex);
            }
            setDragColumnMap(undefined);
        }, onDragCancel: () => setDragColumnMap(undefined) },
        react_1.default.createElement(sortable_1.SortableContext, { items: selectedColumnMaps.map(cm => (cm === null || cm === void 0 ? void 0 : cm.path) || (cm === null || cm === void 0 ? void 0 : cm.value) || ''), strategy: () => null },
            react_1.default.createElement(StyledDiv, { className: classes.join(' ') },
                selectedColumnMaps.map((columnMap, index) => (react_1.default.createElement(SortableQueryFieldSelector_1.SortableQueryFieldSelector, { disabledDrag: !multiple, id: (columnMap === null || columnMap === void 0 ? void 0 : columnMap.path) || (columnMap === null || columnMap === void 0 ? void 0 : columnMap.value) || '', key: columnMap
                        ? (0, exports.getEntityColumnDisplay)(columnMap, vertical)
                        : index.toString(), className: 'column-selector', placeholder: 'Select a Field', freesolo: freesolo, value: columnMap, options: filteredOptions, error: error || (!freesolo && Boolean(columnMap === null || columnMap === void 0 ? void 0 : columnMap.error)), helperText: helperText, autoFocus: shouldAutoFocus &&
                        typeof selectedColumnMaps[selectedColumnMaps.length - 1] ===
                            'undefined', getOptionLabel: option => option ? (0, exports.getEntityColumnDisplay)(option, vertical) : '', onFocus: () => setShouldAutoFocus(false), onChange: columnMap => {
                        selectedColumnMaps[index] = columnMap;
                        setSelectedColumnMaps([...selectedColumnMaps]);
                        if (!selectedColumnMaps.some(cm => typeof cm === undefined || (cm === null || cm === void 0 ? void 0 : cm.error))) {
                            const pathStrings = selectedColumnMaps
                                .map(cm => (cm === null || cm === void 0 ? void 0 : cm.path) || (cm === null || cm === void 0 ? void 0 : cm.value))
                                .filter(path => typeof path !== 'undefined');
                            if (multiple) {
                                onChange === null || onChange === void 0 ? void 0 : onChange(pathStrings);
                            }
                            else {
                                onChange === null || onChange === void 0 ? void 0 : onChange(pathStrings[0]);
                            }
                            onColumnChange === null || onColumnChange === void 0 ? void 0 : onColumnChange(columnMap.path || columnMap.value || '', index, columnMap);
                        }
                    }, onFreeSoloChange: value => {
                        onFreeSoloChange === null || onFreeSoloChange === void 0 ? void 0 : onFreeSoloChange(value, index);
                        // if (multiple) {
                        //   onChange?.(
                        //     columnMaps
                        //       .map(cm => (cm ? getEntityPropertyPath(cm) : cm))
                        //       .filter(cm => typeof cm !== 'undefined') as string[]
                        //   );
                        // } else {
                        //   onChange?.(value);
                        // }
                        onColumnChange === null || onColumnChange === void 0 ? void 0 : onColumnChange(value, index);
                    }, onDelete: onDelete
                        ? () => {
                            selectedColumnMaps.splice(index, 1);
                            setSelectedColumnMaps([...selectedColumnMaps]);
                            onDelete === null || onDelete === void 0 ? void 0 : onDelete(index);
                        }
                        : undefined }))),
                multiple &&
                    (selectedColumnMaps.length === 0 ||
                        typeof selectedColumnMaps[selectedColumnMaps.length - 1] !==
                            'undefined') && (react_1.default.createElement("div", { className: 'add-button-container' },
                    react_1.default.createElement(core_2.IconButton, { size: 'small', className: 'add-column', onClick: () => {
                            setShouldAutoFocus(true);
                            setSelectedColumnMaps([...selectedColumnMaps, undefined]);
                        } },
                        react_1.default.createElement(core_2.Icon, null, "add")))))),
        react_1.default.createElement(core_1.DragOverlay, null, dragColumnMap ? (react_1.default.createElement(SortableQueryFieldSelector_1.DragQueryFieldSelector, { disabled: true, className: 'column-selector', value: dragColumnMap, options: filteredOptions, getOptionLabel: option => option ? (0, exports.getEntityColumnDisplay)(option, vertical) : '' })) : null)));
};
exports.default = ColumnsSelector;
const getEntityColumnDisplay = (columnMap, vertical) => {
    var _a, _b, _c;
    // console.log('columnMap', columnMap);
    const displayName = ((_a = columnMap.column) === null || _a === void 0 ? void 0 : _a.displayName) || '';
    const pathValue = columnMap.path || '';
    const [, select] = pathValue.split('.');
    // add column.path if select column is not the same as the display name.
    // helps to avoid label confusion with similar names, specifically in subqueries.
    // e.g. `Join0 > Id` referencing `Entity > Id` but
    // can also mean another select field like `Query > Id`
    const includePath = !!(select &&
        displayName &&
        (0, lodash_1.camelCase)(displayName) !== (0, lodash_1.camelCase)(select));
    const path = includePath && pathValue ? ` (${pathValue})` : '';
    if (columnMap.value) {
        return columnMap.value + path;
    }
    else if (vertical) {
        return `${columnMap.pluginColumn
            ? columnMap.pluginColumn.name
            : (_b = columnMap.column) === null || _b === void 0 ? void 0 : _b.displayName} ${columnMap.alias ? `(${(0, lodash_1.startCase)(columnMap.alias)})` : ''}${path}`;
    }
    else {
        return `${columnMap.alias ? `${(0, lodash_1.startCase)(columnMap.alias)} \u203A ` : ''}${columnMap.pluginColumn
            ? columnMap.pluginColumn.name
            : (_c = columnMap.column) === null || _c === void 0 ? void 0 : _c.displayName}${path}`;
    }
};
exports.getEntityColumnDisplay = getEntityColumnDisplay;
function getColumnName(column) {
    return column.name || (0, lodash_1.camelCase)(column.displayName);
}
const getQueryAliasColumnMap = (value, queryManager, queryExpression = queryManager.query.config) => {
    // const queryExpression = queryManager.query.config;
    //   queryExpression: QueryExpressionMap | undefined,
    //   entities: EntitySchema[]
    // ) => {
    if (!queryExpression)
        return [];
    return value.map(selection => {
        var _a, _b;
        // selection is an [alias].[property] notation
        const [alias, property] = (selection === null || selection === void 0 ? void 0 : selection.split('.')) || '';
        const joinAttribute = (_a = queryExpression.joinAttributes) === null || _a === void 0 ? void 0 : _a.find(a => { var _a; return ((_a = a.alias) === null || _a === void 0 ? void 0 : _a.name) === alias; });
        // check if mainAlias (FROM TABLE)
        const entity = ((_b = queryExpression.mainAlias) === null || _b === void 0 ? void 0 : _b.name) === alias
            ? queryManager.entities.find(e => { var _a; return e.tableName === ((_a = queryExpression.mainAlias) === null || _a === void 0 ? void 0 : _a.tablePath); }
            // or if alias from join attributes
            )
            : joinAttribute
                ? queryManager.entities.find(e => e.tableName === (joinAttribute === null || joinAttribute === void 0 ? void 0 : joinAttribute.alias.tablePath))
                : // check plugin
                    undefined;
        // get column from parsed property key
        const column = entity === null || entity === void 0 ? void 0 : entity.columns.find(c => getColumnName(c) === property);
        if (!entity || !column) {
            const [plugin, pluginColumn] = queryManager.plugins.reduce((result, plugin) => {
                var _a;
                if (result.length > 0)
                    return result;
                const pluginColumn = (_a = plugin.columns) === null || _a === void 0 ? void 0 : _a.find(c => c.selection === selection);
                return pluginColumn ? [plugin, pluginColumn] : [];
            }, []);
            if (plugin && pluginColumn) {
                return {
                    path: selection,
                    alias: plugin.name,
                    plugin,
                    pluginColumn
                };
            }
        }
        const { subQuery } = (joinAttribute === null || joinAttribute === void 0 ? void 0 : joinAttribute.alias) || {};
        if (entity && column) {
            return {
                path: `${alias}.${getColumnName(column)}`,
                alias,
                entity,
                column
            };
        }
        else if (joinAttribute && subQuery && typeof subQuery === 'object') {
            const map = queryManager
                .getJoinConfigColumnMaps(subQuery, queryManager.entities, joinAttribute.alias.name)
                .find(map => map.path === selection);
            if (map) {
                return map;
            }
        }
        return { value: selection, error: `${value} not found.` };
    });
};
//# sourceMappingURL=ColumnsSelector.js.map